import React from 'react';

const SectionSkew = (props) => (
    <section className={`section-skew mt-12 pt-20 pb-20 u-zIndex100`} {...props}>
        {props.children}
    </section>
);

export default SectionSkew;